module.exports = __webpack_public_path__ + "img/quick-payouts.5b22a9ce.png";